import React from 'react';
import { Route } from 'react-router';
import { bindPageViewTracking } from 'utils/tracking';
import TranslationProvider from 'client/components/translationProvider';

import CodePageContainer from './codePageContainer';
import ContactPageContainer from './contactPageContainer';
import CreatePageContainer from './createPageContainer';
import DownloadPage from './downloadPage';
import JoinEnterpriseApp from './joinEnterpriseApp';
import LandingPage from './landingPage';
import LoggedInPageContainer from './loggedInPageContainer';
import LoginPageContainer from './loginPageContainer';

export default (
  <Route component={TranslationProvider} keys={['common', 'partner']}>
    <Route component={JoinEnterpriseApp}>
      <Route path="/" component={LandingPage} onEnter={bindPageViewTracking()} />
      <Route path="logged-in" component={LoggedInPageContainer} onEnter={bindPageViewTracking()} />
      <Route path="create" component={CreatePageContainer} onEnter={bindPageViewTracking()} />
      <Route path="login" component={LoginPageContainer} onEnter={bindPageViewTracking()} />
      <Route path="code" component={CodePageContainer} onEnter={bindPageViewTracking()} />
      <Route path="contact" component={ContactPageContainer} onEnter={bindPageViewTracking()} />
      <Route path="download" component={DownloadPage} onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
